export const BALANCE_UPLOAD_ROW_KEY_PREFIX = 'balance-upload-';

export const getSelectedBalanceDetails = (selectedRowKeys, balanceUploadDetails) => {
  const selectedIds = new Set(
    (selectedRowKeys || []).map((key) => String(key).replace(BALANCE_UPLOAD_ROW_KEY_PREFIX, '')),
  );
  return (balanceUploadDetails || []).filter((item) => selectedIds.has(String(item.id)));
};

export const applyPriceToDetails = (balanceUploadDetails, selectedDetails, changes) => {
  const selectedIds = new Set(selectedDetails.map((item) => item.id));
  return (balanceUploadDetails || []).map((item) =>
    selectedIds.has(item.id) ? { ...item, ...changes } : item,
  );
};

export const isLoadBalanceSynced = (synced, currentLoadBalance) =>
  synced.id === currentLoadBalance?.id && synced.totalPrice === currentLoadBalance?.totalPrice;

// Every filter field is explicitly unset so that a filter stored by an in-flight request cannot survive.
export const buildClearedFilter = (fieldsValue) => {
  const cleared = { addressIdList: undefined, deliveryCode: undefined };
  Object.keys(fieldsValue || {}).forEach((key) => {
    cleared[key] = undefined;
  });
  return cleared;
};

// Runs fetches one at a time. Requests arriving meanwhile are queued and executed afterwards, so an
// older response can never overwrite a newer (e.g. filtered or updated) list.
// `replace` overrides queued data (search/clear); `onlyIfStale` skips the fetch when already synced.
export const createSerialFetchQueue = (run, isSynced) => {
  let running = false;
  let pending = null;
  let promise = Promise.resolve();

  const drain = async () => {
    try {
      while (pending) {
        const next = pending;
        pending = null;
        if (!(next.onlyIfStale && isSynced())) {
          await run(next.data, next.pageSize);
        }
      }
    } finally {
      running = false;
    }
  };

  return (data, pageSize, options) => {
    const { onlyIfStale = false, replace = false } = options || {};
    const requestData = data || {};
    if (pending) {
      pending = {
        data: replace ? requestData : { ...pending.data, ...requestData },
        pageSize: pageSize || pending.pageSize,
        onlyIfStale: pending.onlyIfStale && onlyIfStale,
      };
    } else {
      pending = { data: requestData, pageSize, onlyIfStale };
    }
    if (!running) {
      running = true;
      promise = drain();
    }
    return promise;
  };
};
